import type { ReactElement, ReactNode } from "react";

import { Badge } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { IRange } from "app/pages/sales-intelligence/types/range";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type FindMarketingChannelsFilter from "../../../models/MarketingChannelsFilter/MarketingChannelsFilter";
import type { IMarketingChannelsFilterDto } from "../../../types/leadsSearchFilters.dto";
import leadsSearchFiltersI18nKeys from "../../../utils/i18n";
import RangeSlider from "../../RangeSlider/RangeSlider";
import { FilterContentContainer } from "../styles";

import { CHANNELS_KEYS, NEW_CHANNEL_METRICS } from "./const";

const getSliderTitle = (key: keyof IMarketingChannelsFilterDto): ReactNode => {
    const label = translate(leadsSearchFiltersI18nKeys.filter(key));

    if (NEW_CHANNEL_METRICS.has(key)) {
        return (
            <Flex
                flexDirection="row"
                gap="8px"
            >
                {label} <Badge type="new" />
            </Flex>
        );
    }

    return label;
};

const MarketingChannelsFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindMarketingChannelsFilter>): ReactElement | null => {
    const handleAfterChange = (key: keyof IMarketingChannelsFilterDto, range: Partial<IRange<number>>) => {
        const updated = { ...value };

        if (is.undefined(range.from) && is.undefined(range.to)) {
            delete updated[key];
        } else {
            updated[key] = range;
        }

        onFilterUpdate(updated);
    };

    return (
        <FilterContentContainer>
            {CHANNELS_KEYS.map((key) => (
                <RangeSlider
                    key={key}
                    name={key}
                    title={getSliderTitle(key)}
                    options={filter.options.channelsShare}
                    value={value?.[key]}
                    onAfterChange={(val: Partial<IRange<number>>) => handleAfterChange(key, val)}
                />
            ))}
        </FilterContentContainer>
    );
};

export default MarketingChannelsFilter;
